export class UpdateCompanyModel {
    id: string;
    name : string;
    description : string;
    email : string;
    url : string;
}